const getValueByPropOrFallback = (targetObject, prop, fallbackValue) => (
  targetObject[prop] ?? fallbackValue
);

export default getValueByPropOrFallback;
